import { styled } from '@clickcease/cc-client-components-lib'

export const StyledSwitchAccounts = styled('div', {
  display: 'flex',
  alignItems: 'flex-end',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: '$4',
  right: '$24',
  top: '$16',
  padding: '$3 $8',

  variants: {
    isHidden: {
      true: {
        display: 'none',
      },
    },
  },

  '@bp1': {
    top: '$4',
  },
})

export const LinkToSwitch = styled('a', {
  all: 'unset',
  display: 'flex',
  alignItems: 'center',
  gap: '$4',
  cursor: 'pointer',

  '> *': {
    cursor: 'pointer',
    '&:hover': {
      color: '$primaryColor',
    },
  },

  '&:hover': {
    '> *': {
      color: '$primaryColor',
    },
  },
})
